import { StyledEm } from '@/cms/Card/components/BaseCardType/RichTextEditor/CardRichTextRenderer.styles';
import { CheckboxField } from '@/components/CheckboxField';
import type { PaymentType } from '@/lib/payment/types';
import { PAYMENT_TYPES } from '@/lib/payment/types';
import { generateDataTestId } from '@/lib/tests';
import { useRegionProvider } from '@/providers/RegionProvider';
import { ConditionsOfSaleAcknowledgeForCembra } from '@/views/PaymentView/components/CembraPayment/messages';

import { Flex } from '../Flex';

import * as M from './messages';
import * as S from './styles';

interface ConditionsOfSaleProps {
  disabled?: boolean;
  isEcsOrder?: boolean;
  multicard?: boolean;
  paymentMethod?: PaymentType;
}
interface TermsFormProps
  extends PrivacyPolicyTermsProps,
    ConditionsOfSaleProps {}

export const TermsForm = ({
  action,
  disabled,
  multicard = false,
  paymentMethod,
}: TermsFormProps) => {
  return (
    <>
      <TermsForm.ConditionsOfSale
        disabled={disabled}
        multicard={multicard}
        paymentMethod={paymentMethod}
      ></TermsForm.ConditionsOfSale>
      <TermsForm.PrivacyPolicyTerms
        action={action}
        disabled={disabled}
      ></TermsForm.PrivacyPolicyTerms>
    </>
  );
};

/**
 * @param isEcsOrder If the checkbox is for an eCS service order
 * @param multicard If the order has been paid with split card
 * @param paymentMethod
 */
const ConditionsOfSaleCheckBox = ({
  disabled,
  isEcsOrder = false,
  multicard = false,
  paymentMethod,
}: ConditionsOfSaleProps) => {
  return (
    <S.TermsFormCol $disabled={disabled} data-test-id='TermsFormCol'>
      <CheckboxField
        data-test-id='TermsFormCheckboxField-conditionsOfSale'
        disabled={disabled}
        name='conditionsOfSale'
        {...generateDataTestId('checkbox', 'conditionsOfSale')}
        defaultChecked={multicard}
      >
        <Flex flexDirection='column' gridGap={2}>
          <S.Text>
            {paymentMethod === PAYMENT_TYPES.CEMBRA ||
            paymentMethod === PAYMENT_TYPES.CEMBRA_INVOICE ? (
              <ConditionsOfSaleAcknowledgeForCembra />
            ) : (
              M.ConditionsOfSaleAcknowledge(isEcsOrder)
            )}
          </S.Text>
          {isEcsOrder && <StyledEm>{M.ConditionsAcceptation}</StyledEm>}
        </Flex>
      </CheckboxField>
    </S.TermsFormCol>
  );
};

type PrivacyPolicyTermsProps = {
  action: string;
  disabled?: boolean;
  extra?: string;
  multicard?: boolean;
};
const PrivacyPolicyTerms = ({
  action,
  disabled,
  extra = '',
}: PrivacyPolicyTermsProps) => {
  const { locale } = useRegionProvider();
  return (
    <S.TermsFormCol $disabled={disabled} data-test-id='TermsFormCol'>
      <S.Text data-test-id='TermsFormTypography'>
        {M.PrivacyPolicyTerms(action, locale.locale, extra)}
      </S.Text>
    </S.TermsFormCol>
  );
};

TermsForm.ConditionsOfSale = ConditionsOfSaleCheckBox;
TermsForm.PrivacyPolicyTerms = PrivacyPolicyTerms;
